import { useEffect, useRef, useState } from 'react';
import { useNav } from '../context/NavContext';

export default function useAndroidBack() {
  const { activeTab, setActiveTab, pop, currentPushed } = useNav();
  const [showExitDialog, setShowExitDialog] = useState(false);
  const cleanupRef = useRef(null);

  useEffect(() => {
    let active = true;

    async function setup() {
      try {
        const { App }       = await import('@capacitor/app');
        const { Capacitor } = await import('@capacitor/core');
        if (!Capacitor.isNativePlatform()) return;

        const handle = await App.addListener('backButton', () => {
          if (!active) return;
          if (currentPushed) { pop(); return; }
          if (activeTab !== 'mosaic') { setActiveTab('mosaic'); return; }
          setShowExitDialog(true);
        });

        cleanupRef.current = () => handle.remove();
      } catch {
        // Not running in Capacitor — no-op on web
      }
    }

    setup();
    return () => {
      active = false;
      cleanupRef.current?.();
    };
  }, [activeTab, currentPushed, pop, setActiveTab]);

  const confirmExit = async () => {
    try {
      const { App } = await import('@capacitor/app');
      App.exitApp();
    } catch {}
  };

  return { showExitDialog, setShowExitDialog, confirmExit };
}
